<div #qrCanvas id="qrCanvas"></div>
<raised-button color="primary" (click)="exportQrCode()" [styles]="{ width: '100%' }">Download QR Code</raised-button>
